<div class="relative flex h-full w-full flex-col">
  <!-- Dismiss button -->
  @if (data.dismissible) {
    <div class="absolute top-0 right-0 pt-4 pr-4">
      <button matIconButton [matDialogClose]="undefined">
        <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    </div>
  }

  <!-- Content -->
  <div
    class="dark:bg-surface flex flex-auto flex-col items-center bg-white p-8 pb-6 sm:flex-row sm:items-start sm:pb-8"
  >
    <!-- Icon -->
    @if (data.icon.show) {
      <div
        class="flex h-[2.5rem] w-[2.5rem] flex-0 items-center justify-center rounded-full p-2 sm:mr-4"
        [ngClass]="{
          'bg-primary-container text-primary dark:text-on-primary-container': data.icon.color === 'info',
          'bg-red-100 text-red-600 dark:bg-red-600 dark:text-red-50': data.icon.color === 'error',
        }"
      >
        <mat-icon class="text-current" [svgIcon]="data.icon.name"></mat-icon>
      </div>
    }

    @if (data.title || data.message) {
      <div class="mt-4 flex flex-col items-center space-y-1 text-center sm:mt-0 sm:items-start sm:pr-8 sm:text-left">
        <!-- Title -->
        @if (data.title) {
          <div class="text-xl leading-6 font-medium" [innerHTML]="data.title"></div>
        }

        <!-- Message -->
        @if (data.message) {
          <div class="text-secondary" [innerHTML]="data.message"></div>
        }
      </div>
    }
  </div>

  <!-- Actions -->
  @if (data.actions.confirm.show || data.actions.cancel.show) {
    <div
      class="dark:bg-surface-container! flex items-center justify-center space-x-3 bg-gray-100! px-6 py-4 sm:justify-end"
    >
      <!-- Cancel -->
      @if (data.actions.cancel.show) {
        <button matButton="outlined" [matDialogClose]="'cancelled'">
          {{ data.actions.cancel.label }}
        </button>
      }

      <!-- Confirm -->
      @if (data.actions.confirm.show) {
        <button
          matButton="filled"
          [matDialogClose]="'confirmed'"
          [ngClass]="{
            'bg-primary! text-on-primary!': data.actions.confirm.color === 'info',
            'bg-red-600! text-white!': data.actions.confirm.color === 'error',
          }"
        >
          {{ data.actions.confirm.label }}
        </button>
      }
    </div>
  }
</div>
